<template>
  <div style="border: 1px solid #ccc">
    <Toolbar
      style="border-bottom: 1px solid #ccc"
      :editor="editModel"
      :defaultConfig="toolbarConfig"
      :mode="mode"
    />
    <Editor
      style="height: 500px; overflow-y: hidden"
      v-model="model"
      :defaultConfig="editorConfig"
      :mode="mode"
      @onCreated="editorCreated"
    />
  </div>
</template>

<script setup>
import { ref } from "vue";
import "@wangeditor/editor/dist/css/style.css"; // 引入 css
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import upload_utils from "@/utils/upload_utils";

const model = defineModel();

const mode = ref("default");
const editModel = ref(null);
const toolbarConfig = ref({
  excludeKeys: [
    "todo",
    "emotion",
    "insertLink",
    "codeBlock",
    "group-video",
    "insertImage",
  ],
});
const editorConfig = ref({
  placeholder: "请输入内容...",
  MENU_CONF: {
    uploadImage: {
      async customUpload(file, insertFn) {
        // 自己实现上传，并得到图片 url alt href
        let url = "",
          alt = "",
          href = "";
        upload_utils
          .uploadImage(file)
          .then((res) => {
            insertFn(res.file_url, alt, href);
          })
          .catch((err) => {
            // ctx.onError()
          });
      },
    },
  },
});

function editorCreated(editor) {
  editModel.value = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
}
</script>

<style scoped></style>
